var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-layout"},[_c('img',{staticClass:"login-layout__logo-image",attrs:{"src":_vm.logo}}),_vm._v(" "),_c('div',{staticClass:"login-layout__login-window"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }